import FLAG from 'config/flag.singleton';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromBeToBody from 'utils/converters/backend/fromBeToBody.util';
import fromStatusToMessageV3 from 'utils/converters/backend/fromStatusToMessageV3.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';
import logger from 'utils/logger.util';
import isEmptyObject from 'utils/predicates/object/isEmptyObject.util';
import isFullObject from 'utils/predicates/object/isFullObject.util';

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const L = logger('determineErrorMessage');

const S_PHRASE_DOT = '. ';
const S_SINGLE_DOT = '.';
const S_DOUBLE_DOT = '..';

const fromEntryToMessage = ([key, val]) => {
  const k = fromAnyToTrimmed(key);
  const v = fromAnyToTrimmed(val);

  if (!k && !v) return '';
  if (!k) return v;
  return `${v} (${k})`;
};

const fromErrorsToStrings = (value) => {
  if (void 1 === value || null === value) return [];
  if (Array.isArray(value)) return value;

  if (isFullObject(value)) {
    return fromObjectToEntries(value).map(fromEntryToMessage);
  }

  return [fromAnyToString(value)];
};

const determineErrorMessage = (response) => {
  if (!response) {
    if (USE_SPAM_LOG) L.debug('()', '(empty)', '', '<-', response);
    return '';
  }

  const { errorMessage, error, errors } = fromBeToBody(response) ?? {};

  const m0a = isFullObject(errors) ? fromErrorsToStrings(errors).join(S_PHRASE_DOT).replace(S_DOUBLE_DOT, S_SINGLE_DOT) : '';

  if (m0a) {
    if (USE_SPAM_LOG) L.debug('()', 'm0a:', m0a, '<-', response);
    return m0a;
  }

  const m0b = isEmptyObject(errors) ? '' : fromAnyToString(errors);
  if (m0b) {
    if (USE_SPAM_LOG) L.debug('()', 'm0b:', m0b, '<-', response);
    return m0b;
  }

  const m1 = fromAnyToString(errorMessage);
  if (m1) {
    if (USE_SPAM_LOG) L.debug('()', 'm1:', m1, '<-', response);
    return m1;
  }

  const m2 = fromAnyToString(error);
  if (m2) {
    if (USE_SPAM_LOG) L.debug('()', 'm2:', m2, '<-', response);
    return m2;
  }

  // if the body has no error message and the HTTP error code is OK, there isn't an error
  if (!response.is || response.is.ok) {
    if (USE_SPAM_LOG) L.debug('()', '(empty)', '<-', 'is:', response.is);
    return '';
  }

  // there is an error, but the message is missing, so default to
  const final = fromStatusToMessageV3(response.status);
  if (USE_SPAM_LOG) L.debug('()', 'final:', final, '<-', 'status:', response.status);

  return final;
};

export default determineErrorMessage;
